<template>
  <router-link
    to="/server_manager"
    v-if="trainingSession.live && csServer && serverLocation"
    class="flex items-center gap-2 border ml-3 bg-gray-800 border-gray-700 rounded-md px-2 py-1 ml-auto hidden lg:flex"
  >
    <div class="relative inline-flex">
      <div class="w-2 h-2 bg-success-500 rounded-full" />
      <div class="absolute w-2 h-2 bg-success-500 rounded-full animate-ping opacity-75" />
    </div>
    <span class="text-sm font-medium text-gray-400">
      <code class="inline text-xs">{{ csServer.ip }}:{{ csServer.port }}</code> -
      {{ serverLocation.name }} {{ latency() }}
    </span>
  </router-link>
  <div v-else-if="serverLocation" class="flex items-center gap-2 bg-gray-800 rounded-md py-2 px-2 ml-auto">
    <div class="relative inline-flex">
      <div class="w-2 h-2 bg-gray-200 rounded-full" />
    </div>
    <span class="text-sm text-text-secondary">
      {{ serverLocation.name }}
      {{ latency() }}
    </span>
  </div>
</template>

<script setup>
import { serverLatency } from '../../utils/server_locations.js';

const props = defineProps({
  trainingSession: {
    type: Object,
    required: true,
  },
});

let serverLocation = props.trainingSession.server_runtimes[0]?.server_location;
let csServer = null;
if (props.trainingSession.cs_servers?.length > 0) {
  csServer = props.trainingSession.cs_servers[0];
  serverLocation = csServer?.server_location;
}

function latency() {
  const ms = serverLatency(serverLocation?.value);

  if (ms) {
    return ` - ${ms}ms`;
  }
}
</script>
